// invest_FE/src/components/verification/AgeConfirmationModal.js
import React from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import './AgeConfirmationModal.css';

const AgeConfirmationModal = ({ isOpen, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  if (!isOpen) {
    return null;
  }

  return ReactDOM.createPortal(
    <div className="modal-overlay">
      <div className="modal-content age-confirmation-modal">
        <h2>{t('ageConfirmationModal.title')}</h2>
        <p>{t('ageConfirmationModal.description')}</p>
        <div className="modal-actions">
          <button onClick={onCancel} className="cancel-btn">
            {t('ageConfirmationModal.cancelButton')}
          </button>
          <button onClick={onConfirm} className="confirm-btn">
            {t('ageConfirmationModal.confirmButton')}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AgeConfirmationModal;
